import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import asyncAction, { isSuccessful } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import questionsTemplates from 'modules/surveys/store/collections/questionsTemplates'
import TemplateForm from 'modules/surveys/store/models/Form'

interface Props {
  toggleModal: React.Dispatch<React.SetStateAction<boolean>>
}

const AddSurveyQuestionnaireTemplateModal = ({ toggleModal }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const templateForm = React.useRef(
    new Form(
      {
        title: null,
        type: TemplateForm.Types.survey,
      },
      {
        title: 'string',
        type: 'string',
      }
    )
  ).current

  const onSubmit = async () => {
    const result = await asyncAction(() => {
      return questionsTemplates.create(templateForm.data())
    })

    if (isSuccessful(result)) {
      return navigate(
        navigation.settings.surveys.template.fullPath({
          questionsTemplateId: result.value.id,
        })
      )
    }
  }

  return (
    <Modal
      illustration="add-block"
      title={i18n.t('app_store_v2.apps.surveys.settings.templates.modal.title')}
      description={i18n.t('app_store_v2.apps.surveys.settings.templates.modal.description')}
      onClose={() => toggleModal(false)}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={() => toggleModal(false)}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="primary" disabled={!templateForm.get('title').value} submit>
            {i18n.t('app_store_v2.apps.performance_v2.settings.templates.modal.button')}
          </Button>
        </>
      }
    >
      <Text
        label={i18n.t('app_store_v2.apps.performance_v2.settings.templates.modal.label')}
        placeholder={i18n.t(
          'app_store_v2.apps.performance_v2.settings.templates.modal.placeholder'
        )}
        field={templateForm.get('title')}
      />
    </Modal>
  )
}

export default observer(AddSurveyQuestionnaireTemplateModal)
